import crypto from 'crypto-js';
import hash from 'hashids';
import config from "../config/settings.js";

const encryptionHelper = {
    key: config.APP_KEY,
    salt: config.APP_SALT,

    encrypt(data) {
        try {
            if (!this.key) {
                return {
                    result: "fail",
                    error: ""
                }
            }
            const encrypted = crypto.AES.encrypt(JSON.stringify(data), this.key).toString();
            return {
                result: "success",
                response: encrypted
            }
        } catch (error) {
            console.error('Encryption Failed:', error);
            return {
                result: "fail",
                error: "Encryption Failed"
            }
        }
    },

    decrypt(data) {
        try {
            if (!this.key) {
                return {
                    result: "fail",
                    error: ""
                }
            }
            const decrypted = crypto.AES.decrypt(data, this.key).toString(crypto.enc.Utf8);
            return {
                result: "success",
                response: JSON.parse(decrypted)
            }
        } catch (error) {
            console.error('Encryption Failed:', error);
            return {
                result: "fail",
                error: "Encryption Failed"
            }
        }
    },

    encode(id) {
        try {
            if (!this.salt) {
                return {
                    result: "fail",
                    error: "Salt Not Set"
                }
            }
            const encode = new hash(this.salt, 12);
            let encoded = encode.encode(id);
            const padded = encoded.padStart(36, '0');
            const formatted = `${padded.substring(0, 8)}-${padded.substring(8, 4)}-${padded.substring(12, 4)}-${padded.substring(16, 4)}-${padded.substring(20)}`;
            return {
                result: "success",
                response: formatted
            }
        } catch (error) {
            console.error('Encoding Failed:', error);
            return {
                result: "fail",
                error: "Encoding Failed"
            }
        }
    },

    decode(id) {
        try {
            if (!this.salt) {
                return {
                    result: "fail",
                    error: "Salt Not Set"
                }
            }
            const decode = new hash(this.salt, 12);
            const decoded = decode.decode(encodedId);
            // return decoded.length > 0 ? decoded[0] : null;
            return {
                result: "success",
                response: decoded.length > 0 ? decoded[0] : null
            }
        } catch (error) {
            console.error('Decoding Failed:', error);
            return {
                result: "fail",
                error: "Decoding Failed"
            }
        }
    },
};

export default encryptionHelper;